import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {LayersSet} from "./LayersSet";
import {DevilsCrossRoadFreespinReel} from "./DevilsCrossRoadFreespinReel";
import {
    Coordinate2d,
    SimpleReelModelSymbolData
} from "../../core/reel/simplereel/SimpleReelModel";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";


export class DevilsCrossroadFreespinReelAreaView extends PIXI.Container implements StageLayer {
    public layers:LayersSet;
    public reels:DevilsCrossRoadFreespinReel [][];
    private _reelGlowVerticals: PIXI.spine.Spine [] = [];
    private _reelGlowHorizontals: PIXI.spine.Spine [] = [];
    private _bgSprite:PIXI.Sprite = new PIXI.Sprite();
    private _reelBacklight: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "DevilsCrossRoadFreespinReelAreaView";
        this.init();

        /*const arr:number [] = Array.from({ length: 36 }, (value, index) => index);
        arr.forEach((val) => {
            //console.log("SHORT ARR: " + val);
            this.testCoinToAnimation(val);
        });*/
        //this.tmpDebugHandler();
    }

    private tmpDebugHandler():void {
        const ref = this;

        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    break; // 0
                case 54:
                    break; // 6
                case 55:
                    break; // 7
                case 56:
                    break; // 8
                case 57:
                    break; // 9
            }
        }, false);
    }

    public reInitReel(): void {
        this.reels.forEach((reels) => {
            reels.forEach((reel) => {
               reel.reInitReel([]);
            });
        })
    }

    private init() {
        this.layers = new LayersSet();

        // TODO: Calculate starting positions.
        const startPositions:Coordinate2d[][] = [];

        const startX:number = 67.5;
        const startY:number = 54;
        const symWidth:number = 120; //DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH;
        const symHeight:number = 100; //DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;

        [0, 1, 2, 3, 4, 5].forEach((rowIndex) => {
            [0, 1, 2, 3, 4, 5].forEach((colIndex) => {
                startPositions.push([{
                    x: startX + (rowIndex * symWidth),
                    y: startY + (colIndex * symHeight)
                }])
            });
        });


        this.reels = [];

        let reelId = 0;
        for (let i:number = 0; i < startPositions.length; i++) {
            this.reels[i] = [];
            for (let j:number = 0; j < startPositions[i].length; j++) {
                const pos = startPositions[i][j];
                const reel = new DevilsCrossRoadFreespinReel(reelId);
                reelId++;
                reel.position.set(pos.x, pos.y);
                this.layers.addLayerSet(reel.layers);
                this.reels[i].push(reel);
                //reel.addDebugTint();
                //debugger;
            }
        }

        const bgSprite: PIXI.Sprite = new PIXI.Sprite(DevilsCrossRoad.assetLoader.getTextures("fs_reel")[0]);
        this._bgSprite = bgSprite;
        this._bgSprite.visible=false;
        this.addChild(this._bgSprite);


        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.layers.maskedHighlight);
        this.addChild(this.layers.win);
        this.addChild(this.layers.winOver);

        this.addChild(this.layers.overlay);
        /*this.layers.all.forEach((layer, index) => {
            layer.scale.set(0.8, 0.8);
        });*/

        this._reelBacklight = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("reelBacklight"));
        //console.log("Reel Backlight Spine Animations", this._reelBacklight.state.data.skeletonData.animations);
        this._reelBacklight.visible=false;
        this.addChild(this._reelBacklight);
        this.playBacklightIdle();

        this.setUpVerticalGlow();
        this.setUpHorizontalGlow();

        //this.createCoinSpinSprite();
        this.onOrientationChanged();
    }

    public playBacklightIdle(): void {
        const animation:PIXI.spine.core.Animation = this._reelBacklight.spineData.findAnimation("idle");
        const animationAlpha:number = 1;
        const mixDuration:number = 0;

        SpineGSAPWrapper.setAnimation(this._reelBacklight, 0, animation, true, animationAlpha, mixDuration);
    }

    private setUpVerticalGlow():void {

        const startX:number = 133;
        const startY:number = 350;

        [0, 1, 2 , 3, 4].forEach((idx) => {
            const spine: PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("reelGlowVertical"));
            this._reelGlowVerticals.push(spine);
            const spineWidth:number = 120;
            spine.y = startY;
            spine.x = startX + (idx * spineWidth);
            spine.state.setEmptyAnimation(0, 0);
            spine.visible = false;
            this.addChild(spine);

            //if(idx === 0) {
            //this.playVerticalIdle(idx);
            //console.log("Reel Glow Vertical Animations", spine.state.data.skeletonData.animations);
            //}
        });

        /*this.playVerticalSequence(0);
        this.playVerticalSequence(1);
        this.playVerticalSequence(2);
        this.playVerticalSequence(3);
        this.playVerticalSequence(4);*/
    }

    public resetGlows():void {
        [0, 1, 2, 3, 4].forEach((id) => {
            this.resetVerticalGlow(id);
            this.resetHorizontalGlow(id);
        });
    }

    private setUpHorizontalGlow():void {

        const startX:number = 432;
        const startY:number = 218;

        [0, 1, 2 , 3, 4].forEach((idx) => {
            const spine: PIXI.spine.Spine = new PIXI.spine.Spine(DevilsCrossRoad.assetLoader.getSpineAsset("reelGlowHorizontal"));
            this._reelGlowHorizontals.push(spine);
            const spineHeight:number = 97;

            spine.y = startY  + (idx * spineHeight);
            spine.x = startX;
            spine.state.setEmptyAnimation(0, 0);
            spine.visible = false;

            this.addChild(spine);
            //this.playHorizontalIdle(idx);

            //if(idx === 0) {
            //console.log("Reel Glow Horizontal Animations", spine.state.data.skeletonData.animations);
            //}
        });

        //this.playHorizontalIdle(4);
        // playHorizontalSequence(id:number, trackIndex:number = 0, animationAlpha:number = 1, mixDuration:number = 0)

        /*this.playHorizontalSequence(0);
        this.playHorizontalSequence(1);
        this.playHorizontalSequence(2);
        this.playHorizontalSequence(3);
        this.playHorizontalSequence(4);*/
    }

    public resetVerticalGlow(id:number): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(!this._reelGlowVerticals[id].visible) {
            return tl;
        }

        tl.add(gsap.fromTo(this._reelGlowVerticals[id], 0.2, {
            alpha: 1
        }, {
            alpha: 0
        }));
        tl.add(() => {
            this._reelGlowVerticals[id].state.setEmptyAnimation(0, 0);
            this._reelGlowVerticals[id].visible = false;
            this._reelGlowVerticals[id].alpha = 1;
        });
        return tl;
    }

    public resetHorizontalGlow(id:number): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if(!this._reelGlowHorizontals[id].visible) {
            return tl;
        }
        tl.add(gsap.fromTo(this._reelGlowHorizontals[id], 0.2, {
            alpha: 1
        }, {
            alpha: 0
        }));
        tl.add(() => {
            this._reelGlowHorizontals[id].state.setEmptyAnimation(0, 0);
            this._reelGlowHorizontals[id].visible = false;
            this._reelGlowHorizontals[id].alpha = 1;
        });
        return tl;
    }

    public playVerticalSequence(id:number, trackIndex:number = 0, animationAlpha:number = 1, mixDuration:number = 0): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const activateGlowAnim:PIXI.spine.core.Animation = this._reelGlowVerticals[id].spineData.findAnimation("glow_activate");
        const idleGlowAnim:PIXI.spine.core.Animation = this._reelGlowVerticals[id].spineData.findAnimation("glow_idle");

        tl.add([
            () => {
                this._reelGlowVerticals[id].visible = true;
            },
            () => SpineGSAPWrapper.setAnimation(this._reelGlowVerticals[id], 0, activateGlowAnim, true, animationAlpha, mixDuration)
        ]);
        tl.add(() => SpineGSAPWrapper.setAnimation(this._reelGlowVerticals[id], 0, idleGlowAnim, true, animationAlpha, mixDuration), activateGlowAnim.duration);

        return tl;
    }

    public playHorizontalSequence(id:number, trackIndex:number = 0, animationAlpha:number = 1, mixDuration:number = 0): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const activateGlowAnim:PIXI.spine.core.Animation = this._reelGlowHorizontals[id].spineData.findAnimation("glow_activate");
        const idleGlowAnim:PIXI.spine.core.Animation = this._reelGlowHorizontals[id].spineData.findAnimation("glow_idle");

        tl.add([
            () => {
                this._reelGlowHorizontals[id].visible = true;
            },
            () => SpineGSAPWrapper.setAnimation(this._reelGlowHorizontals[id], 0, activateGlowAnim, true, animationAlpha, mixDuration)
        ]);
        tl.add(() => SpineGSAPWrapper.setAnimation(this._reelGlowHorizontals[id], 0, idleGlowAnim, true, animationAlpha, mixDuration), activateGlowAnim.duration);

        return tl;
    }

    public playVerticalIdle(id:number): void {
        const animation:PIXI.spine.core.Animation = this._reelGlowVerticals[id].spineData.findAnimation("glow_activate");
        const animationAlpha:number = 1;
        const mixDuration:number = 0;

        SpineGSAPWrapper.setAnimation(this._reelGlowVerticals[id], 0, animation, true, animationAlpha, mixDuration);
    }

    public playHorizontalIdle(id:number): void {
        const animation:PIXI.spine.core.Animation = this._reelGlowHorizontals[id].spineData.findAnimation("glow_activate");
        const animationAlpha:number = 1;
        const mixDuration:number = 0;

        SpineGSAPWrapper.setAnimation(this._reelGlowHorizontals[id], 0, animation, true, animationAlpha, mixDuration);
    }


    private createCoinSpinSprite(indexPos:number):TimelineSprite {
        /*
            "V/V_1"
            "V/V_2"
            "V/V_3"
            "V/V_2"
            "V/V_1"
         */
        const textures:PIXI.Texture [] = [
            DevilsCrossRoad.assetLoader.getTextures("V/V_1")[0],
            DevilsCrossRoad.assetLoader.getTextures("V/V_2")[0],
            DevilsCrossRoad.assetLoader.getTextures("V/V_3")[0],
            DevilsCrossRoad.assetLoader.getTextures( "V/V_4")[0],
            DevilsCrossRoad.assetLoader.getTextures("V/V_5")[0]
        ];
        const coinsTlSprite:TimelineSprite = new TimelineSprite(textures);
        //coinsTlSprite.scale.set(0.95, 0.95);
        coinsTlSprite.scale.set(0.9, 0.9);
        coinsTlSprite.anchor.set(0.25, -0.75);
        DevilsCrossRoad.endBonusView.addCoinSprite(coinsTlSprite);
        coinsTlSprite.position.set(this.reels[indexPos][0].position.x + 15, this.reels[indexPos][0].position.y);
        coinsTlSprite.hide();

        //coinsTlSprite.playLoop();
        //gsap.timeline().add(() => {
            //coinsTlSprite.stopLoop();
            //coinsTlSprite.setFrame(0);
        //}, 5).play();

        return coinsTlSprite;
    }

    public playBonusEndCoinAnimation(idsToPlay: number [], flattenedCoinValues: number []): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({ease: "slow(0.5, 0.8)"});

        const xOffset:number = (NolimitApplication.isLandscape)? 30 : 12.5;
        const yOffset:number = (NolimitApplication.isLandscape)? 25 : 60;

        /*

     ids:   0   1  2   3  4  5   6  7  8  9 10 11   12 13 14 15 16 17   18 19 20 21 22 23   24 25 26 27 28 29           30 31 32 33 34 35
            [0, 1, 0, 20, 0, 0] [0, 0, 0, 1, 0, 0]  [0, 1, 0, 0, 0, 1]  [0, 0, 0, 0, 0, 0]  [0, 0, 0, 1, 0, 0]  [25: total, 0, 0, 0, 0, 0]

         Invalid (for coin-anim) id:s:
         [0, 6, 12, 18, 24, 30, 31, 32, 33, 34, 35]

         */

        const coinsToAnimate: TimelineSprite [] = [];
        const coinValueToIncrementWith: number [] = [];
        const winCap:boolean = DevilsCrossRoad.model.gameData.brokeTheBank;

        idsToPlay.forEach((id, index) => {
            if([0, 6, 12, 18, 24, 30, 31, 32, 33, 34, 35].indexOf(id) < 0) {
                coinsToAnimate.push(this.createCoinSpinSprite(id));
                coinValueToIncrementWith.push(flattenedCoinValues[index]);
            }
        });

        let winCapSet:boolean = false;
        coinsToAnimate.forEach((coin, index) => {
            let origin:PIXI.Point = new PIXI.Point(coin.x, coin.y);
            tl.add(() => {
                coin.show();
                coin.playLoop();
                coin.anchor.set(0.25, -0.75);
                DevilsCrossRoad.endBonusView.show();
                DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_COIN_SEND.next()});
            });

            if(coinValueToIncrementWith[index] < 100) {
                tl.add([
                    gsap.fromTo(coin, 0.2, {
                        x: origin.x - xOffset,
                        y: origin.y - yOffset
                    }, {
                        x: 360,
                        y: 360
                    }),
                    gsap.fromTo(coin.anchor, 0.2, {
                        x: 0.25,
                        y: -0.75
                    }, {
                        x: 0.5,
                        y: 0.5
                    }),
                    gsap.fromTo(coin.scale, 0.2, {
                        x: 0.9,
                        y: 0.9
                    }, {
                        x: 1.1,
                        y: 1.1
                    })
                ], (winCap)? 0.4 : "+=0.1");
            }
            else {
                tl.add([
                    gsap.fromTo(coin.anchor, 0.2, {
                        x: 0.25,
                        y: -0.75
                    }, {
                        x: 0.5,
                        y: 0.5
                    }),
                    gsap.fromTo(coin.scale, 0.2, {
                        x: 0.9,
                        y: 0.9
                    }, {
                        x: 1.3,
                        y: 1.3
                    })
                ], (winCap)? 0.4 : "+=0.1");
                tl.add([
                    gsap.fromTo(coin, 0.2, {
                        x: origin.x - 30,
                        y: origin.y - 30
                    }, {
                        x: 360,
                        y: 360
                    }),
                    gsap.fromTo(coin.scale, 0.2, {
                        x: 1.3,
                        y: 1.3
                    }, {
                        x: 1.1,
                        y: 1.1
                    })
                ], (winCap)? 0.4 : ">");
            }
            tl.add(() => {
                coin.hide();
            });

            if(DevilsCrossRoad.model.gameData.brokeTheBank) {
                //if(!winCapSet) {
                    tl.add(DevilsCrossRoad.endBonusView.updateTextAnimationWinCap(), 0.4);
                    winCapSet = true;
                //}
            }
            else {
                tl.add(DevilsCrossRoad.endBonusView.updateTextAnimation(coinValueToIncrementWith[index]));
            }
        });

        // TODO: Ensure end value.
        return tl;
    }

    public testCoinToAnimation(indexPosition: number): void {
        const coin:TimelineSprite = this.createCoinSpinSprite(indexPosition);
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            coin.show();
            coin.playLoop();
        });

    }

    public playCoinToAnimation(from:PIXI.Point, to:PIXI.Point, originId:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const coin:TimelineSprite = this.createCoinSpinSprite(originId);

        const xOffset:number = (NolimitApplication.isLandscape)? 30 : 12.5;
        const yOffset:number = (NolimitApplication.isLandscape)? 25 : 58;

        tl.add(() => {
            coin.show();
            coin.playLoop();
            DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_COIN_SEND.next()});
        });
        tl.fromTo(coin, 0.5, {
            x: this.reels[from.x][from.y].position.x - xOffset,
            y: this.reels[from.x][from.y].position.y - yOffset
        }, {
            x: this.reels[to.x][to.y].position.x - xOffset,
            y: this.reels[to.x][to.y].position.y - yOffset
        });
        tl.add(() => {
            coin.stopLoop();
            coin.setFrame(0);
            coin.hide();

            this.layers.overlay.removeChild(coin);
            coin.destroy();
        });

        //tl.play();

        return tl;
    }

    public initReels() {
        for (let i:number = 0; i < this.reels.length; i++) {
            for (let j:number = 0; j < this.reels[i].length; j++) {
                if([0, 6, 12, 18, 24, 31, 32, 33, 34, 35, 36].indexOf(i) > -1) {
                    this.reels[i][j].init([""]);
                    this.reels[i][j].fSReelVisible = false;
                    this.reels[i][j].model.setAsStickyReel();
                }
                else {
                    this.reels[i][j].init(["X"]);
                }
                this.reels[i][j].model.active = true;
                this.reels[i][j].model.collectable = true;

                if(i === 30) {
                    this.reels[i][j].fSReelVisible = false;
                    this.reels[i][j].model.setAsStickyReel();
                }
            }
        }
    }

    public resetEmptyReels(serverReels: string [][], stickyCoinsValues: number [][], hardReset:boolean = false):void {

        const flattenedResult = serverReels.reduce((accumulator, value) => accumulator.concat(value), []);

        flattenedResult.forEach((sym, index) => {

            const conv: PIXI.Point = DevilsCrossRoadFreespinReel.reelConversion[index];

            if(hardReset) {
                this.reels[index][0].init(["X","X","X","X"], true);

            }
            else if(index !== 30 && sym === "X") {
                this.reels[index][0].init(["X", "X", "X", "X"], true);
            }
        });

        /*for (let i:number = 0; i < this.reels.length; i++) {
            for (let j:number = 0; j < this.reels[i].length; j++) {
                if(this.reels[i][j].model.symbols[1].name === "X") {
                    this.reels[i][j].model.symbols.forEach((sym) => {
                        //sym.
                    });
                    this.reels[i][j].model.forceRemoveSymbols();
                    this.reels[i][j].init(["X", "X", "X"]);

                    // TODO: Reset textures
                    console.log("RESET X", this.reels[i][j].model.symbols);
                    //debugger;
                }
            }
        }*/
    }

    public setReelsWithData(serverReels: string [][], stickyCoinsValues: number [][]) {

        /*this.reels.forEach((reel) => {
            if(reel[0] && reel[0].model.symbols[0]) {
                reel[0].model.symbols[0].positionable.position.y = -DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;
                reel[0].model.state = SimpleReelModelState.IDLE;
            }
        });*/

        const flattenedResult = serverReels.reduce((accumulator, value) => accumulator.concat(value), []);

        flattenedResult.forEach((sym, index) => {

            const conv: PIXI.Point = DevilsCrossRoadFreespinReel.reelConversion[index];
            if(stickyCoinsValues[conv.x][conv.y] > 0 && index !== 30) {
                this.reels[index][0].model.addCloneSymbol(sym, stickyCoinsValues[conv.x][conv.y]);
            }
        });
    }

    getAllVisibleSymbols():SimpleReelModelSymbolData[]{
        const result:SimpleReelModelSymbolData[] = [];
        for (let i:number = 0; i < this.reels.length; i++){
            for (let j:number = 0; j < this.reels[i].length; j++){
                result.push(this.getVisibleSymbolDataAt(i,j));
            }
        }
        return result;
    }

    getAllVisibleSymbolDataAt():SimpleReelModelSymbolData[][]{
        const result:SimpleReelModelSymbolData[][] = [];
        for (let i:number = 0; i < this.reels.length; i++){
            result[i] = [];
            for (let j:number = 0; j < this.reels[i].length; j++){
                result[i][j] = this.getVisibleSymbolDataAt(i,j);
            }
        }
        return result;
    }

    getVisibleSymbolDataAt(column:number, row:number):SimpleReelModelSymbolData {
        return this.reels[column][row].model.getVisibleSymbolAt(0);
    }

    public  getReel(column:number): DevilsCrossRoadFreespinReel {
        return this.reels[column][0];
    }

    public switchReelMode(mode:string) {
        if(mode === DevilsCrossRoadGameMode.NORMAL || mode === DevilsCrossRoadGameMode.NORMAL_AVALANCHE) {
            this.reels.forEach((reelList) => {
                reelList.forEach((reel) => {
                    reel.fSReelVisible = false;
                });
            });

            this._bgSprite.visible = false;
            this._reelBacklight.visible = false;
            DevilsCrossRoad.reels.reelView.show(true);
        }
        else if(mode === DevilsCrossRoadGameMode.FREESPIN) {
            this.reels.forEach((reelList) => {
                reelList.forEach((reel) => {
                    reel.fSReelVisible = true;
                });
            });

            this._bgSprite.visible = true;
            this._reelBacklight.visible = true;
            DevilsCrossRoad.reels.reelView.show(false);
        }
        else if(mode === DevilsCrossRoadGameMode.SUPER_FREESPIN) {
            this.reels.forEach((reelList) => {
                reelList.forEach((reel) => {
                    reel.fSReelVisible = true;
                });
            });

            this._bgSprite.visible = true;
            this._reelBacklight.visible = true;
            DevilsCrossRoad.reels.reelView.show(false);
        }
    }

    public onOrientationChanged() {
        if(NolimitApplication.isLandscape) {
            this.x = -75;
            this.y = 30;

            this._bgSprite.position.set(72.5, 35)
            this._reelBacklight.position.set(360 + 75, 370 - 32.5);


            const startPositions:Coordinate2d[][] = [];

            const startX:number = 67.5;
            const startY:number = 54;
            const symWidth:number = 120; //DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH;
            const symHeight:number = 100; //DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;

            [0, 1, 2, 3, 4, 5].forEach((rowIndex) => {
                [0, 1, 2, 3, 4, 5].forEach((colIndex) => {
                    startPositions.push([{
                        x: startX + (rowIndex * symWidth),
                        y: startY + (colIndex * symHeight)
                    }])
                });
            });


            for (let i:number = 0; i < startPositions.length; i++) {
                for (let j:number = 0; j < startPositions[i].length; j++) {
                    const pos = startPositions[i][j];
                    const reel = this.reels[i][j];
                    reel.position.set(pos.x, pos.y);
                }
            }

            const startXglow:number = 133;
            const startYglow:number = 350;
            const spineWidth:number = 120;

            this._reelGlowVerticals.forEach((glowSpine, idx) => {
                glowSpine.position.set(startXglow + (idx * spineWidth), startYglow);
            });

            const startXglowH:number = 432;
            const startYglowH:number = 218;
            const spineHeight:number = 97;

            this._reelGlowHorizontals.forEach((glowSpine, idx) => {
                glowSpine.position.set(startXglowH, startYglowH + (idx * spineHeight));
            });

        }
        else {
            this.x = -45;
            this.y = 0;

            this._bgSprite.position.set(72.5 - 15, 35)
            this._reelBacklight.position.set(360 + 60, 370 - 32.5);

            const startPositions:Coordinate2d[][] = [];

            const startX:number = 67.5 - 15;
            const startY:number = 54;
            const symWidth:number = 120; //DevilsCrossRoadGameConfig.FS_SYMBOL_WIDTH;
            const symHeight:number = 100; //DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT;

            [0, 1, 2, 3, 4, 5].forEach((rowIndex) => {
                [0, 1, 2, 3, 4, 5].forEach((colIndex) => {
                    startPositions.push([{
                        x: startX + (rowIndex * symWidth),
                        y: startY + (colIndex * symHeight)
                    }])
                });
            });


            for (let i:number = 0; i < startPositions.length; i++) {
                for (let j:number = 0; j < startPositions[i].length; j++) {
                    const pos = startPositions[i][j];
                    const reel = this.reels[i][j];
                    reel.position.set(pos.x, pos.y);
                }
            }

            const startXglow:number = 133 - 15;
            const startYglow:number = 350;
            const spineWidth:number = 120;

            this._reelGlowVerticals.forEach((glowSpine, idx) => {
                glowSpine.position.set(startXglow + (idx * spineWidth), startYglow);
            });

            const startXglowH:number = 432 - 15;
            const startYglowH:number = 218;
            const spineHeight:number = 97;

            this._reelGlowHorizontals.forEach((glowSpine, idx) => {
                glowSpine.position.set(startXglowH, startYglowH + (idx * spineHeight));
            });
        }
    }

}